import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Subject } from "rxjs";

@Injectable()
export class AppStateService {
  // Vars
  public aktuellerAppStatus: Object;
  private loginURL = "LiftplanII/LoginOut/emailLogin.php";
  private appStatus = new Subject<Object>();

  appStatus$ = this.appStatus.asObservable();
  constructor(private http: HttpClient, private router: Router) {
    this.appStatusVonServerHolen();
  }
  // Service message commands
  kranGewaehltNeu(kran: Object) {
    this.appStatusSetzen(kran);
  }

  aktuellerMenuepunktSetzen(status: string) {
    this.appStatusSetzen({ aktuellerMenuePunkt: status });
  }
  meuePunktStatusSetzen(neuerMenueStatus: Object) {
    const menueStatus: Object = {};
    for (const menuePunkt in neuerMenueStatus) {
      if (neuerMenueStatus.hasOwnProperty(menuePunkt)) {
        menueStatus[menuePunkt] = neuerMenueStatus[menuePunkt];
      }
    }
    this.appStatusSetzen(menueStatus);
  }
  appStatusSetzen(neuerAppStatus: Object) {
    if (this.aktuellerAppStatus === undefined) {
      this.aktuellerAppStatus = {};
    }
    for (const status in neuerAppStatus) {
      if (neuerAppStatus.hasOwnProperty(status)) {
        this.aktuellerAppStatus[status] = neuerAppStatus[status];
      }
    }
    // Neuen Status auf Server speichern
    const theURL = [this.loginURL + "?action=speichereZustand"];
    for (const status in this.aktuellerAppStatus) {
      if (this.aktuellerAppStatus.hasOwnProperty(status)) {
        theURL.push(
          status + "=" + this.statusZuString(this.aktuellerAppStatus[status])
        );
      }
    }
    this.http.get(theURL.join("&")).toPromise().then();
    this.appStatus.next(this.aktuellerAppStatus);
  }
  statusZuString(status) {
    if (Array.isArray(status)) {
      let temp = "[";
      status.forEach((element) => {
        temp += this.statusZuString(element) + ",";
      });
      status = temp.substr(0, temp.length - 1) + "]";
    }
    return status;
  }
  appStatusReset(initialerAppStatus: Object) {
    this.aktuellerAppStatus = initialerAppStatus;
    // this.appStatus.next(this.aktuellerAppStatus);
    this.appStatusSetzen(initialerAppStatus);
  }
  appStatusVonServerHolen() {
    const theURL = this.loginURL + "?action=ladeZustand";
    const thePromise = this.http.get(theURL).toPromise();
    thePromise.then((res) => this.appStatusAnlegen(res));
    return thePromise;
  }
  appStatusAnlegen(res) {
    this.aktuellerAppStatus = {};
    for (const status in res) {
      if (res.hasOwnProperty(status)) {
        this.aktuellerAppStatus[status] =
          res[status] === "undefined" ? undefined : res[status];
      }
    }
    if (
      res["loginStatus"] === undefined ||
      res["loginStatus"] === null ||
      res["loginStatus"] === "" ||
      res["loginStatus"] === "notLoggedIn" ||
      res["loginStatus"] === "loggedOff"
    ) {
      this.router.navigate(["/login"]);
    }
    this.appStatus.next(this.aktuellerAppStatus);
  }
  holeEinheitenSystem(was: string): string {
    switch (was) {
      case "G":
      case "g":
        if (this.aktuellerAppStatus["einheitenSystem"] === "M") {
          return "t";
        } else {
          return "kip";
        }
      case "L":
      case "l":
        if (this.aktuellerAppStatus["einheitenSystem"] === "M") {
          return "m";
        } else {
          return "ft";
        }
      default:
        break;
    }
  }
}
